module.exports = __webpack_public_path__ + "img/cs-top-image.393ff10c.svg";